import { VisualizerSchemaType } from './schema';

const visualizerOscilloscope: VisualizerSchemaType = {
  type: 'oscilloscope',
  numberOfSamples: '64' as const,
  windowInSeconds: 0.1,
  posterization: 3,
  amplitude: 4,
  padding: 50,
};

const visualizerSpectrum: VisualizerSchemaType = {
  type: 'spectrum',
  numberOfSamples: '64' as const,
  mirrorWave: true,
  linesToDisplay: 50,
  freqRangeStartIndex: 0,
};

export const audiogramDefaultStyleProps = {
  titleColor: '#ffffff',
  visualizerColor: '#00d795',
  captionsTextColor: '#ffffff',
  backgroundType: 'solid' as const,
  backgroundColor: '#000848',
};

export const audiogramDefaultProps = {
  ...audiogramDefaultStyleProps,

  variant: '1x1' as const,

  // audio settings
  audioOffsetInSeconds: 0,

  onlyDisplayCurrentSentence: true,
  captionsType: 'default',

  visualizer: visualizerSpectrum,
};
